export default __webpack_public_path__ + "static/media/no-tax.b50b1b47.svg";